<script setup lang="ts">
import type { FieldProps } from "./field.types";
import { useField } from "./useField";
import { fieldLabelWrapperClasses, fieldContentClasses, fieldRequiredClasses } from "./field.styles";

defineOptions({ name: "EField" });

const props = withDefaults(defineProps<FieldProps>(), {
  required: false,
  disabled: false,
  color: "neutral",
  variant: "outline",
  size: "md",
  orientation: "vertical",
});

const { contentRef, classes, messageClasses, messageText, handleLabelClick } = useField({ props });

defineExpose({ contentRef });
</script>

<template>
  <div part="base" :class="classes">
    <!-- part="label" is conditional (v-if) — absent from DOM when no label prop is set -->
    <div v-if="props.label" part="label" :class="fieldLabelWrapperClasses" @click="handleLabelClick">
      <span class="e-label-text">
        {{ props.label }}
      </span>
      <span v-if="props.required" :class="fieldRequiredClasses" aria-label="required"> * </span>
    </div>

    <div ref="contentRef" part="content" :class="fieldContentClasses">
      <slot />
    </div>

    <div v-if="messageText" part="message" :class="messageClasses">
      {{ messageText }}
    </div>
  </div>
</template>

<style>
:host {
  width: 100%;
}
</style>
